import {
  FormattedDate,
  fromDate as from,
} from '../../../utils/date/FormattedDate';

export type DateFormat = FormattedDate<'MMddyyyy'>;

export const fromDate = from<'MMddyyyy'>('MMddyyyy');
